
export enum RankedDivisionTypes {
    Grandmaster = 0,
    Master = 1,
    Diamond = 2,
    Platinum = 3,
    Gold = 4,
    Silver = 5,
    Bronze = 6,
    None = 7,
}

export enum RankedSubDivisionTypes {
    None = 0,
    I = 1,
    II = 2,
    III = 3,
    IV = 4,
    V = 5,
}
